import React from 'react';

/**
 * Round agent avatar; falls back to a branded initial.
 * @param {{name?: string, avatar?: string, brand: string, size?: number}} props
 * @returns {JSX.Element}
 */
export default function AgentAvatar({ name, avatar, brand, size = 44 }) {
  const box = { width: size, height: size };
  if (avatar && typeof avatar === 'string') {
    return <img src={avatar} alt={name || 'Agent'} style={box} className="rounded-full object-cover border border-slate-200 dark:border-slate-700 shrink-0" />;
  }
  return (
    <div style={{ ...box, backgroundColor: brand }} className="rounded-full flex items-center justify-center text-white font-bold shrink-0">
      {(name || '').trim().charAt(0).toUpperCase() || '?'}
    </div>
  );
}
